/* Product slider */
$(document).ready(function(){
   setTimeout(function(){
    $('.product_slider').slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: true
    })
    .on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
   set_arrows();
    },2000);
    $('input#inputText-f-0').bind('input', function() {
      var c = this.selectionStart,
          r = /[^a-z0-9 .]/gi,
          v = $(this).val();
      if(r.test(v)) {
        $(this).val(v.replace(r, ''));
        c--;
      }
      this.setSelectionRange(c, c);
    });
  
    var SetInterval = null;
    SetInterval = setInterval(personalize, 500);
    function personalize() {
      var PId = getUrlParameter('pid');
      if (PId) {
        if ($('.product_slider').hasClass('slick-initialized')){
          $('.product_slider').slick('slickGoTo', $('.customiser-container .product_item[data-pid=' + PId + ']').attr('data-slick-index')-1);
        }
        $('.customiser-container .product_item[data-pid=' + PId + '] .product_select_button').click();
      }
      setTimeout(function(){
        clearInterval(SetInterval)
      },3000);
      if ($('.product_item[data-pid=' + PId + '].slick-current').length != 0) {
        var getVariantID = getUrlParameter('variant'),
            getJson = $('#VariantsJson-' + PId).html(),
            productJson = jQuery.parseJSON(getJson),
            productJsonVariants = productJson.variants;
        for (i = 0; i < productJsonVariants.length; i++) {
          if (productJsonVariants[i].id == getVariantID) {
            forEach('.sheath_wrapper_option .sheath_wrapper_btn',productJsonVariants[i].option1)
            forEach('.gift_wrapper_option .gift_wrapper_btn',productJsonVariants[i].option2)
          }
        }
      }
    }
});

setTimeout(function(){
  if(!$('.product_slider').hasClass('slick-initialized')){
    $('.product_slider').slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
    set_arrows();
  }
},2500);

function set_arrows(){
  $('.product_slider .slick-prev').html($("#prevArrowTemplate").html());
  $('.product_slider .slick-next').html($("#nextArrowTemplate").html());
}

/* Product Canvas */

var text_title =  $('#inputText-f-0').val();
var canvas = document.getElementById('knife_preview');
var ctx = canvas.getContext('2d');

const img1 = new Image();
img1.onload = function() {
  $('#default_img').attr('data-width',this.width);
  $('#default_img').attr('data-height',this.height);
}
img1.src = $('#default_img').attr('src');

setTimeout(function(){
  ctx.canvas.width = $('#default_img').data('width');
  ctx.canvas.height = $('#default_img').data('height');
},500);
var img = new Image();
img.crossOrigin="anonymous";

function DrawPlaceholder(text_title) {
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  $('#default_img').hide();
  $('#knife_preview').show();
  img.onload = function() {
    DrawOverlay(img);
    text_title = text_title.toUpperCase();
    var xval = $('#xval').val();
    var yval = $('#yval').val();
    var demo_fontsize = $('#r1').val(); 
    var newstring = text_title;
    $('#js-font-engraving').val(newstring);
    // $('#js-font-engraving').val();
    var getfontval = $('input[name="properties[Font Engraving]"]:checked').val();
    var productname = $('.customize_image .product_select_name').val();
    var fontname = $('#js-font-style').val();
     // DynamicText(text_title,demo_fontsize,xval,yval,getfontval);
     // return;
    if(fontname == 'osaka-re'){
      if(productname == 'manta-series-essential-set'){
        var fontsize = 55;
        var x = 860;
        var y = 160;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 850;
        var y1 = 685;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 945;
        var y2 = 1215;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      } else if(productname == 'kuro-knife'){
        var fontsize = 40;
        var x = 1150;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mori-knife'){
        var fontsize = 40;
        var x = 1195;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'ko-itamae-knife'){
        var fontsize = 40;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mizu-keiryu-set'){
        var fontsize = 40;
        var x = 1070;
        var y = 900;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
        var fontsize = 55;
        var x = 915;
        var y = 270;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 890;
        var y1 = 650;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 1040;
        var y2 = 1070;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'agila-mini-serbian'){
        var fontsize = 65;
        var x = 1120;
        var y = 525;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'shogun-series-santoku-178mm'){    // new changes
        var fontsize = 60;
        var x = 1020;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'multi-purpose-boning'){
        var fontsize = 65;
        var x = 1120;
        var y = 665;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-santoku'){
        var fontsize = 65;
        var x = 1020;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'chefs-knife-micarta-handle'){
        var fontsize = 55;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'serbian-knife'){
        var fontsize = 55;
        var x = 1140;
        var y = 585;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'honesuki'){
        var fontsize = 55;
        var x = 1010;
        var y = 630;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'daovua-bunka-blacksmiths-finish'){
        var fontsize = 55;
        var x = 1230;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chefs-knife'){
        var fontsize = 55;
        var x = 1280;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-utility-knife'){
        var fontsize = 55;
        var x = 840;
        var y = 675;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-bunka'){
        var fontsize = 55;
        var x = 760;
        var y = 660;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-nakiri'){
        var fontsize = 55;
        var x = 520;
        var y = 630;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-cleaver'){
        var fontsize = 55;
        var x = 1150;
        var y = 565;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-santoku'){
        var fontsize = 55;
        var x = 1070;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-gyuto-knife'){
        var fontsize = 55;
        var x = 1070;
        var y = 810;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-nakiri'){
        var fontsize = 55;
        var x = 1040;
        var y = 830;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'paring-knife'){
        var fontsize = 45;
        var x = 980;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-ktip'){
        var fontsize = 55;
        var x = 1130;
        var y = 810;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-series-knife-set'){
        var fontsize = 50;
        var x = 1050;
        var y = 320;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 50;
        var x1 = 1050;
        var y1 = 670;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 45;
        var x2 = 1070;
        var y2 = 980;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
        var fontsize3 = 35;
        var x3 = 1185;
        var y3 = 1245;
        DynamicText(text_title,fontsize3,x3,y3,getfontval);
      }else if(productname == 'bread-knife'){
        var fontsize = 55;
        var x = 1250;
        var y = 720;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set'){
        var fontsize = 55;
        var x = 1060;
        var y = 432;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 1085;
        var y1 = 825;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 1200;
        var y2 = 1120;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-general-cleaver'){
        var fontsize = 55;
        var x = 905;
        var y = 655;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'outdoor-slicer'){
        var fontsize = 45;
        var x = 1025;
        var y = 494;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set-1'){
        var fontsize = 55;
        var x = 1060;
        var y = 415;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 1060;
        var y1 = 760;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 45;
        var x2 = 1080;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-butcher'){
        var fontsize = 55;
        var x = 1250;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'butcher'){
        var fontsize = 55;
        var x = 1120;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'gyuto-221mm'){
        var fontsize = 55;
        var x = 1150;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'modern-kyoto-series-set'){
        var fontsize = 40;
        var x = 1170;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'traditional-kyoto-series-set'){
        var fontsize = 40;
        var x = 1170;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-gyuto'){
        var fontsize = 45;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sakura-bloom'){
        var fontsize = 45;
        var x = 1080;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yumi-gyuto'){
        var fontsize = 45;
        var x = 1110;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-petty'){
        var fontsize = 40;
        var x = 890;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-gyuto-petty-set'){
        var fontsize = 40;
        var x = 965;
        var y = 485;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 40;
        var x1 = 960;
        var y1 = 885;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-150mm'){
        var fontsize = 32;
        var x = 860;
        var y = 682;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-220mm'){
        var fontsize = 38;
        var x = 980;
        var y = 664;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sato-k-tip-knife-set'){
        var fontsize = 38;
        var x = 970;
        var y = 470;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 32;
        var x1 = 1000;
        var y1 = 848;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'agila-bunka'){
        var fontsize = 55;
        var x = 940;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'midori-resin'){
        var fontsize = 50;
        var x = 1160;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chef-190mm'){
        var fontsize = 55;
        var x = 1050;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku-1'){
        var fontsize = 55;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku'){
        var fontsize = 55;
        var x = 1150;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }
    }else if(fontname == 'CopperplateGothicBold'){
      if(productname == 'agila-mini-serbian'){
        var fontsize = 50;
        var x = 1120;
        var y = 525;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'shogun-series-santoku-178mm'){    // new changes
        var fontsize = 60;
        var x = 1020;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'multi-purpose-boning'){
        var fontsize = 50;
        var x = 1120;
        var y = 665;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'kuro-knife'){
        var fontsize = 40;
        var x = 1150;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mori-knife'){
        var fontsize = 40;
        var x = 1195;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'ko-itamae-knife'){
        var fontsize = 40;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-keiryu-set'){
        var fontsize = 45;
        var x = 1070;
        var y = 900;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-santoku'){
        var fontsize = 50;
        var x = 1020;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'manta-series-essential-set'){
        var fontsize = 47;
        var x = 860;
        var y = 160;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 47;
        var x1 = 850;
        var y1 = 685;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 945;
        var y2 = 1215;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      } else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
        var fontsize = 47;
        var x = 915;
        var y = 270;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 47;
        var x1 = 890;
        var y1 = 650;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 1040;
        var y2 = 1070;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      } else if(productname == 'chefs-knife-micarta-handle'){
        var fontsize = 47;
        var x = 880;
        var y = 615;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'serbian-knife'){
        var fontsize = 48;
        var x = 1140;
        var y = 582;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'honesuki'){
        var fontsize = 50;
        var x = 1010;
        var y = 630;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'daovua-bunka-blacksmiths-finish'){
        var fontsize = 47;
        var x = 1230;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chefs-knife'){
        var fontsize = 47;
        var x = 1280;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-utility-knife'){
        var fontsize = 50;
        var x = 800;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-bunka'){
        var fontsize = 50;
        var x = 760;
        var y = 660;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-nakiri'){
        var fontsize = 50;
        var x = 520;
        var y = 630;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-cleaver'){
        var fontsize = 48;
        var x = 1150;
        var y = 565;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-santoku'){
        var fontsize = 50;
        var x = 1070;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-gyuto-knife'){
        var fontsize = 50;
        var x = 1070;
        var y = 810;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-nakiri'){
       var fontsize = 50;
        var x = 1040;
        var y = 830;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'paring-knife'){
        var fontsize = 40;
        var x = 980;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-ktip'){
        var fontsize = 47;
        var x = 1130;
        var y = 810;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-series-knife-set'){
        var fontsize = 45;
        var x = 1050;
        var y = 320;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 45;
        var x1 = 1050;
        var y1 = 670;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 40;
        var x2 = 1070;
        var y2 = 980;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
        var fontsize3 = 30;
        var x3 = 1185;
        var y3 = 1245;
        DynamicText(text_title,fontsize3,x3,y3,getfontval);
      }else if(productname == 'bread-knife'){
        var fontsize = 50;
        var x = 1250;
        var y = 720;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set'){
        var fontsize = 50;
        var x = 1060;
        var y = 432;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 50;
        var x1 = 1085;
        var y1 = 825;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 40;
        var x2 = 1200;
        var y2 = 1122;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-general-cleaver'){
        var fontsize = 50;
        var x = 905;
        var y = 657;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'outdoor-slicer'){
        var fontsize = 40;
        var x = 1030;
        var y = 494;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set-1'){
        var fontsize = 47;
        var x = 1060;
        var y = 410;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 48;
        var x1 = 1060;
        var y1 = 760;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 40;
        var x2 = 1080;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-butcher'){
        var fontsize = 55;
        var x = 1250;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'butcher'){
        var fontsize = 50;
        var x = 1120;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'gyuto-221mm'){
        var fontsize = 50;
        var x = 1150;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'modern-kyoto-series-set'){
        var fontsize = 35;
        var x = 1170;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'traditional-kyoto-series-set'){
        var fontsize = 35;
        var x = 1170;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-gyuto'){
        var fontsize = 45;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sakura-bloom'){
        var fontsize = 45;
        var x = 1080;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yumi-gyuto'){
        var fontsize = 45;
        var x = 1110;
        var y = 750;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-petty'){
        var fontsize = 40;
        var x = 890;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-gyuto-petty-set'){
        var fontsize = 40;
        var x = 965;
        var y = 485;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 40;
        var x1 = 960;
        var y1 = 885;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-150mm'){
        var fontsize = 26;
        var x = 860;
        var y = 682;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-220mm'){
        var fontsize = 38;
        var x = 980;
        var y = 664;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sato-k-tip-knife-set'){
        var fontsize = 38;
        var x = 970;
        var y = 472;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 26;
        var x1 = 1000;
        var y1 = 846;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'agila-bunka'){
        var fontsize = 55;
        var x = 940;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'midori-resin'){
        var fontsize = 50;
        var x = 1160;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chef-190mm'){
        var fontsize = 45;
        var x = 1050;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku-1'){
        var fontsize = 45;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku'){
        var fontsize = 45;
        var x = 1150;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }
    }else if(fontname == 'MainFrameDemo'){
      if(productname == 'agila-mini-serbian'){
        var fontsize = 60;
        var x = 1120;
        var y = 525;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'shogun-series-santoku-178mm'){    // new changes
        var fontsize = 65;
        var x = 1020;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'kuro-knife'){
        var fontsize = 40;
        var x = 1150;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mori-knife'){
        var fontsize = 50;
        var x = 1195;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'ko-itamae-knife'){
        var fontsize = 50;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-keiryu-set'){
        var fontsize = 45;
        var x = 1070;
        var y = 900;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'multi-purpose-boning'){
        var fontsize = 60;
        var x = 1120;
        var y = 665;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-santoku'){
        var fontsize = 60;
        var x = 1000;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'manta-series-essential-set'){
        var fontsize = 60;
        var x = 860;
        var y = 165;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 60;
        var x1 = 850;
        var y1 = 690;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 48;
        var x2 = 945;
        var y2 = 1220;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
        var fontsize = 60;
        var x = 915;
        var y = 270;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 60;
        var x1 = 890;
        var y1 = 650;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 48;
        var x2 = 1040;
        var y2 = 1070;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'chefs-knife-micarta-handle'){
        var fontsize = 60;
        var x = 880;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'serbian-knife'){
        var fontsize = 60;
        var x = 1140;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'honesuki'){
        var fontsize = 60;
        var x = 1010;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'daovua-bunka-blacksmiths-finish'){
        var fontsize = 60;
        var x = 1230;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chefs-knife'){
        var fontsize = 60;
        var x = 1280;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-utility-knife'){
        var fontsize = 60;
        var x = 820;
        var y = 675;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-bunka'){
        var fontsize = 60;
        var x = 760;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-nakiri'){
        var fontsize = 60;
        var x = 520;
        var y = 645;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-cleaver'){
        var fontsize = 60;
        var x = 1150;
        var y = 575;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-santoku'){
        var fontsize = 60;
        var x = 1070;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-gyuto-knife'){
        var fontsize = 60;
        var x = 1070;
        var y = 825;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-nakiri'){
        var fontsize = 60;
        var x = 1040;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'paring-knife'){
        var fontsize = 55;
        var x = 980;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-ktip'){
        var fontsize = 60;
        var x = 1120;
        var y = 815;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-series-knife-set'){
        var fontsize = 59;
        var x = 1050;
        var y = 330;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 59;
        var x1 = 1050;
        var y1 = 680;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 54;
        var x2 = 1070;
        var y2 = 980;	
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
        var fontsize3 = 43;
        var x3 = 1185;
        var y3 = 1250;
        DynamicText(text_title,fontsize3,x3,y3,getfontval);
      }else if(productname == 'bread-knife'){
        var fontsize = 60;
        var x = 1250;
        var y = 725;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set'){
        var fontsize = 55;
        var x = 1055;
        var y = 438;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 1085;
        var y1 = 825;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 45;
        var x2 = 1200;
        var y2 = 1122;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-general-cleaver'){
        var fontsize = 60;
        var x = 905;
        var y = 660;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'outdoor-slicer'){
        var fontsize = 55;
        var x = 1025;
        var y = 498;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set-1'){
        var fontsize = 57;
        var x = 1060;
        var y = 425;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 57;
        var x1 = 1060;
        var y1 = 770;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 55;
        var x2 = 1080;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-butcher'){
        var fontsize = 55;
        var x = 1250;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'butcher'){
        var fontsize = 60;
        var x = 1120;
        var y = 625;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'gyuto-221mm'){
        var fontsize = 60;
        var x = 1150;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'modern-kyoto-series-set'){
        var fontsize = 50;
        var x = 1170;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'traditional-kyoto-series-set'){
        var fontsize = 50;
        var x = 1170;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-gyuto'){
        var fontsize = 55;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sakura-bloom'){
        var fontsize = 55;
        var x = 1080;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yumi-gyuto'){
        var fontsize = 55;
        var x = 1110;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-petty'){
        var fontsize = 50;
        var x = 890;
        var y = 697;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-gyuto-petty-set'){
        var fontsize = 50;
        var x = 965;
        var y = 490;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 50;
        var x1 = 960;
        var y1 = 890;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-150mm'){
        var fontsize = 36;
        var x = 860;
        var y = 688;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-220mm'){
        var fontsize = 48;
        var x = 980;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sato-k-tip-knife-set'){
        var fontsize = 48;
        var x = 965;
        var y = 478;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 34;
        var x1 = 1000;
        var y1 = 852;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'agila-bunka'){
        var fontsize = 55;
        var x = 940;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'midori-resin'){
        var fontsize = 55;
        var x = 1160;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chef-190mm'){
        var fontsize = 55;
        var x = 1050;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku-1'){
        var fontsize = 55;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku'){
        var fontsize = 55;
        var x = 1150;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }
    }else if(fontname == 'Bloom'){
      if(productname == 'agila-mini-serbian'){
        var fontsize = 35;
        var x = 1105;
        var y = 515;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'shogun-series-santoku-178mm'){    // new changes
        var fontsize = 40;
        var x = 1020;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'kuro-knife'){
        var fontsize = 40;
        var x = 1150;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mori-knife'){
        var fontsize = 40;
        var x = 1195;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'ko-itamae-knife'){
        var fontsize = 40;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-keiryu-set'){
        var fontsize = 35;
        var x = 1070;
        var y = 893;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'multi-purpose-boning'){
        var fontsize = 35;
        var x = 1120;
        var y = 665;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-santoku'){
        var fontsize = 35;
        var x = 1000;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'manta-series-essential-set'){
        var fontsize = 35;
        var x = 840;
        var y = 155;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 35;
        var x1 = 830;
        var y1 = 680;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 28;
        var x2 = 925;
        var y2 = 1210;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
        var fontsize = 30;
        var x = 900;
        var y = 260;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 30;
        var x1 = 870;
        var y1 = 640;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 30;
        var x2 = 1020;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'chefs-knife-micarta-handle'){
        var fontsize = 35;
        var x = 865;
        var y = 605;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'serbian-knife'){
        var fontsize = 35;
        var x = 1140;
        var y = 575;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'honesuki'){
        var fontsize = 40;
        var x = 1010;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'daovua-bunka-blacksmiths-finish'){
        var fontsize = 60;
        var x = 1230;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chefs-knife'){
        var fontsize = 35;
        var x = 1265;
        var y = 675;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-utility-knife'){
        var fontsize = 60;
        var x = 820;
        var y = 675;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-bunka'){
        var fontsize = 60;
        var x = 760;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-nakiri'){
        var fontsize = 60;
        var x = 520;
        var y = 645;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-cleaver'){
        var fontsize = 35;
        var x = 1130;
        var y = 565;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-santoku'){
        var fontsize = 35;
        var x = 1050;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-gyuto-knife'){
        var fontsize = 35;
        var x = 1055;
        var y = 815;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-nakiri'){
        var fontsize = 35;
        var x = 1025;
        var y = 830;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'paring-knife'){
        var fontsize = 55;
        var x = 980;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-ktip'){
        var fontsize = 35;
        var x = 1110;
        var y = 810;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-series-knife-set'){
        var fontsize = 59;
        var x = 1050;
        var y = 330;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 59;
        var x1 = 1050;
        var y1 = 680;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 54;
        var x2 = 1070;
        var y2 = 980;	
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
        var fontsize3 = 43;
        var x3 = 1185;
        var y3 = 1250;
        DynamicText(text_title,fontsize3,x3,y3,getfontval);
      }else if(productname == 'bread-knife'){
        var fontsize = 35;
        var x = 1240;
        var y = 710;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set'){
        var fontsize = 55;
        var x = 1055;
        var y = 438;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 1085;
        var y1 = 825;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 45;
        var x2 = 1200;
        var y2 = 1122;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-general-cleaver'){
        var fontsize = 35;
        var x = 895;
        var y = 650;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'outdoor-slicer'){
        var fontsize = 35;
        var x = 1015;
        var y = 488;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set-1'){
        var fontsize = 57;
        var x = 1060;
        var y = 425;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 57;
        var x1 = 1060;
        var y1 = 770;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 55;
        var x2 = 1080;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-butcher'){
        var fontsize = 55;
        var x = 1250;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'butcher'){
        var fontsize = 60;
        var x = 1120;
        var y = 625;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'gyuto-221mm'){
        var fontsize = 40;
        var x = 1145;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'modern-kyoto-series-set'){
        var fontsize = 25;
        var x = 1155;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'traditional-kyoto-series-set'){
        var fontsize = 50;
        var x = 1170;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-gyuto'){
        var fontsize = 30;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sakura-bloom'){
        var fontsize = 35;
        var x = 1070;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yumi-gyuto'){
        var fontsize = 30;
        var x = 1110;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-petty'){
        var fontsize = 50;
        var x = 890;
        var y = 697;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-gyuto-petty-set'){
        var fontsize = 50;
        var x = 965;
        var y = 490;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 50;
        var x1 = 960;
        var y1 = 890;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-150mm'){
        var fontsize = 22;
        var x = 840;
        var y = 685;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-220mm'){
        var fontsize = 48;
        var x = 980;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sato-k-tip-knife-set'){
        var fontsize = 48;
        var x = 965;
        var y = 478;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 34;
        var x1 = 1000;
        var y1 = 852;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'agila-bunka'){
        var fontsize = 35;
        var x = 940;
        var y = 630;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'midori-resin'){
        var fontsize = 35;
        var x = 1145;
        var y = 765;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chef-190mm'){
        var fontsize = 35;
        var x = 1040;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku-1'){
        var fontsize = 30;
        var x = 1130;
        var y = 775;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku'){
        var fontsize = 55;
        var x = 1150;
        var y = 775;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }
    }else if(fontname == 'Ninja'){
      if(productname == 'agila-mini-serbian'){
        var fontsize = 45;
        var x = 1120;
        var y = 525;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'shogun-series-santoku-178mm'){    // new changes
        var fontsize = 50;
        var x = 1020;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'kuro-knife'){
        var fontsize = 40;
        var x = 1150;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'mori-knife'){
        var fontsize = 40;
        var x = 1195;
        var y = 790;
        DynamicText(text_title,fontsize,x,y,getfontval);
      } else if(productname == 'ko-itamae-knife'){
        var fontsize = 40;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-keiryu-set'){
        var fontsize = 42;
        var x = 1070;
        var y = 900;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'multi-purpose-boning'){
        var fontsize = 45;
        var x = 1120;
        var y = 665;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-santoku'){
        var fontsize = 45;
        var x = 1000;
        var y = 620;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'manta-series-essential-set'){
        var fontsize = 45;
        var x = 860;
        var y = 160;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 45;
        var x1 = 850;
        var y1 = 685;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 33;
        var x2 = 945;
        var y2 = 1215;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
        var fontsize = 40;
        var x = 910;
        var y = 270;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 40;
        var x1 = 890;
        var y1 = 650;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 35;
        var x2 = 1040;
        var y2 = 1070;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'chefs-knife-micarta-handle'){
        var fontsize = 45;
        var x = 880;
        var y = 610;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'serbian-knife'){
        var fontsize = 45;
        var x = 1140;
        var y = 580;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'honesuki'){
        var fontsize = 35;
        var x = 1010;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'daovua-bunka-blacksmiths-finish'){
        var fontsize = 60;
        var x = 1230;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chefs-knife'){
        var fontsize = 45;
        var x = 1280;
        var y = 680;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-utility-knife'){
        var fontsize = 60;
        var x = 820;
        var y = 675;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-bunka'){
        var fontsize = 60;
        var x = 760;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yume-nakiri'){
        var fontsize = 60;
        var x = 520;
        var y = 645;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mini-cleaver'){
        var fontsize = 45;
        var x = 1150;
        var y = 575;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-santoku'){
        var fontsize = 45;
        var x = 1070;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-gyuto-knife'){
        var fontsize = 45;
        var x = 1070;
        var y = 815;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-nakiri'){
        var fontsize = 45;
        var x = 1040;
        var y = 840;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'paring-knife'){
        var fontsize = 55;
        var x = 980;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'mizu-ktip'){
        var fontsize = 45;
        var x = 1120;
        var y = 815;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'itamae-series-knife-set'){
        var fontsize = 59;
        var x = 1050;
        var y = 330;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 59;
        var x1 = 1050;
        var y1 = 680;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 54;
        var x2 = 1070;
        var y2 = 980;	
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
        var fontsize3 = 43;
        var x3 = 1185;
        var y3 = 1250;
        DynamicText(text_title,fontsize3,x3,y3,getfontval);
      }else if(productname == 'bread-knife'){
        var fontsize = 45;
        var x = 1250;
        var y = 725;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set'){
        var fontsize = 55;
        var x = 1055;
        var y = 438;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 55;
        var x1 = 1085;
        var y1 = 825;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 45;
        var x2 = 1200;
        var y2 = 1122;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-general-cleaver'){
        var fontsize = 45;
        var x = 905;
        var y = 650;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'outdoor-slicer'){
        var fontsize = 40;
        var x = 1025;
        var y = 488;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'san-mai-set-1'){
        var fontsize = 57;
        var x = 1060;
        var y = 425;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 57;
        var x1 = 1060;
        var y1 = 770;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
        var fontsize2 = 55;
        var x2 = 1080;
        var y2 = 1060;
        DynamicText(text_title,fontsize2,x2,y2,getfontval);
      }else if(productname == 'the-butcher'){
        var fontsize = 55;
        var x = 1250;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'butcher'){
        var fontsize = 60;
        var x = 1120;
        var y = 625;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'gyuto-221mm'){
        var fontsize = 45;
        var x = 1150;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'modern-kyoto-series-set'){
        var fontsize = 37;
        var x = 1170;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'traditional-kyoto-series-set'){
        var fontsize = 50;
        var x = 1170;
        var y = 780;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-gyuto'){
        var fontsize = 40;
        var x = 1130;
        var y = 785;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sakura-bloom'){
        var fontsize = 40;
        var x = 1080;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'yumi-gyuto'){
        var fontsize = 40;
        var x = 1110;
        var y = 760;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-petty'){
        var fontsize = 50;
        var x = 890;
        var y = 697;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'samurai-gyuto-petty-set'){
        var fontsize = 50;
        var x = 965;
        var y = 490;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 50;
        var x1 = 960;
        var y1 = 890;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-150mm'){
        var fontsize = 32;
        var x = 860;
        var y = 688;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'k-tip-hybrid-resin-220mm'){
        var fontsize = 48;
        var x = 980;
        var y = 670;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'sato-k-tip-knife-set'){
        var fontsize = 48;
        var x = 965;
        var y = 478;
        DynamicText(text_title,fontsize,x,y,getfontval);
        var fontsize1 = 34;
        var x1 = 1000;
        var y1 = 852;
        DynamicText(text_title,fontsize1,x1,y1,getfontval);
      }else if(productname == 'agila-bunka'){
        var fontsize = 45;
        var x = 940;
        var y = 640;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'midori-resin'){
        var fontsize = 40;
        var x = 1160;
        var y = 770;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'agila-chef-190mm'){
        var fontsize = 40;
        var x = 1050;
        var y = 690;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku-1'){
        var fontsize = 40;
        var x = 1130;
        var y = 775;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }else if(productname == 'limited-samurai-santoku'){
        var fontsize = 55;
        var x = 1150;
        var y = 775;
        DynamicText(text_title,fontsize,x,y,getfontval);
      }
    }else{
        var fontsize = 60;
        var x = 1330;
        var y = 590;
        DynamicText(text_title,fontsize,x,y,getfontval);
    }   
    
//     DynamicText(text_title);
  };
  img.src = $('#default_img').attr('src');
}

function DynamicText(text_title,fontsize,xval,yval,getfontval){
  // console.log("INNN")
  do {
    fontsize--;
    ctx.font = fontsize+"px "+getfontval;
  } while (ctx.measureText(text_title).width > canvas.width - 550);
  ctx.textAlign = "right";
  var productname = $('.customize_image .product_select_name').val();
  if(productname == 'serbian-knife'){
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    
    gradient.addColorStop("0", "#f5f5f5");
    gradient.addColorStop("0.5", "#f5f5f5");
    gradient.addColorStop("1.0", "#f5f5f5");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'honesuki'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'agila-chef-190mm'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "right";
  }else if(productname == 'agila-bunka'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'daovua-bunka-blacksmiths-finish'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#f5f5f5");
    gradient.addColorStop("0.5", "#f5f5f5");
    gradient.addColorStop("1.0", "#f5f5f5");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'agila-mini-serbian'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'shogun-series-santoku-178mm'){     // new change
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'multi-purpose-boning'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'mini-santoku'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'manta-series-essential-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'chefs-knife-micarta-handle'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'agila-chefs-knife'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#f5f5f5");
    gradient.addColorStop("0.5", "#f5f5f5");
    gradient.addColorStop("1.0", "#f5f5f5");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'agila-utility-knife'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'yume-bunka'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'yume-nakiri'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'mini-cleaver'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'classic-chefs-starter-set' || productname == 'beowulf-magnetic-board-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'itamae-santoku'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'itamae-gyuto-knife'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'itamae-nakiri'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'paring-knife'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'mizu-ktip'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'itamae-series-knife-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'the-butcher'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#f5f5f5");
    gradient.addColorStop("0.5", "#f5f5f5");
    gradient.addColorStop("1.0", "#f5f5f5");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'butcher'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#f5f5f5");
    gradient.addColorStop("0.5", "#f5f5f5");
    gradient.addColorStop("1.0", "#f5f5f5");
    // Fill with gradient
    ctx.fillStyle = gradient;
    ctx.textAlign = "left";
  }else if(productname == 'gyuto-221mm'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'modern-kyoto-series-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'traditional-kyoto-series-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'limited-samurai-gyuto'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#CCC");
    gradient.addColorStop("0.5", "#CCC");
    gradient.addColorStop("1.0", "#CCC");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'sakura-bloom'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'yumi-gyuto'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'samurai-petty'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'samurai-gyuto-petty-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'k-tip-hybrid-resin-150mm'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'k-tip-hybrid-resin-220mm'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'sato-k-tip-knife-set'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'limited-samurai-santoku-1'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#ccc");
    gradient.addColorStop("0.5", "#ccc");
    gradient.addColorStop("1.0", "#ccc");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else if(productname == 'limited-samurai-santoku'){
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#ccc");
    gradient.addColorStop("0.5", "#ccc");
    gradient.addColorStop("1.0", "#ccc");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }else{
    // Create gradient
    var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
    gradient.addColorStop("0", "#000");
    gradient.addColorStop("0.5", "#000");
    gradient.addColorStop("1.0", "#000");
    // Fill with gradient
    ctx.fillStyle = gradient;
  }
  ctx.fillText(text_title,xval,yval);
}

function DrawOverlay(img) {
  ctx.drawImage(img,0,0,ctx.canvas.width,ctx.canvas.height);
}

document.getElementById('inputText-f-0').addEventListener('keyup', function() {
  DrawPlaceholder(this.value);
});

$('.random_field').keyup(function(){
  	var text = $('#inputText-f-0').val();
	DrawPlaceholder(text);
});

$('input[name="properties[Font Engraving]"]').click(function(){
  var text_title = $('#inputText-f-0').val();
  DrawPlaceholder(text_title);
});
$('.btn-product-item').click(function(){
  var text_title = $('#inputText-f-0').val();
  DrawPlaceholder(text_title);
});

$(document).ready(function(){
  $('.btn-product-item').click(function(){
    $('.btn-product-item').removeClass('active');
    $(this).addClass('active');
    $('#js-font-style').val($(this).find('[data-select-font]').val());
    setlimit();
  });
  var maxLength = $('.limit_text').text();
  function setlimit(){
    var textlen = maxLength - $('.engraving-text-limit').val().length;
    if(textlen <= 0){
      $('.limit_text').css('color', 'red');
    }else{
      $('.limit_text').css('color', 'inherit');
    }
    $('.limit_text').text(textlen);
    var vallength = $('#js-font-engraving').val();
    if(vallength == ''){
      $('.addToCart_button .add-to-cart').attr('disabled','disabled');
    }else{
      $('.addToCart_button .add-to-cart').removeAttr('disabled','disabled');
    }
    var disabled = $('.product_select_button.active').hasClass('disabled');
    if(disabled){
      $('.addToCart_button .add-to-cart').attr('disabled','disabled');
      $('.addToCart_button .add-to-cart span').text('Sold Out');
    }else{
      $('.addToCart_button .add-to-cart').removeAttr('disabled','disabled'); 
      $('.addToCart_button .add-to-cart span').text('Add to cart');
    }
  }
  $('.engraving-text-limit').keyup(function() {
    setlimit();
  });
});

$('.sheath_wrapper_option .sheath_wrapper_btn input').click(function() {
    getProductData('.sheath_wrapper_btn', '.gift_wrapper_block', $(this),1);
});
$('.gift_wrapper_option .gift_wrapper_btn input').click(function() {
    getProductData('.gift_wrapper_btn', '.sheath_wrapper_block', $(this),2);
});

function getProductData(selector1, selector2, isthis, options) {
  var getProductData = $('.get_proudct_data').html(),
      getProductData = JSON.parse(getProductData),
      getVal = isthis.val(),
      getVariants = getProductData.variants,
      selectedVal = $(selector2).find('label.active input').val();
  $(selector1).removeClass('active');
  isthis.parents('.form-btn').addClass('active');
  for (let index = 0; index < getVariants.length; index++) {
    var checkStatus = options == 1 ? getVariants[index].option1 == getVal && getVariants[index].option2 == selectedVal : options == 2 ? getVariants[index].option1 == selectedVal && getVariants[index].option2 == getVal : false
    if (checkStatus) {
      var variant = getVariants[index];
      if (variant.available == false) {
        $('.addToCart_button .add-to-cart').attr('disabled', 'disabled').find('span').text('Sold Out');
      } else {
        $('.addToCart_button .add-to-cart').removeAttr("disabled").find('span').text('Add to cart');
      }
      $('.dm-js-form .product-select').val(variant.id);
      $('.current-selection-total [data-price]').html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));
      $('.grid-product__price[data-pricechange="pricechange-' + getProductData.id + '"]').html(theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat));
    }
  }
}

$('.product_select_button').change(function(){
  $('.step-two').slideDown();
  var getimage = $(this).parent().find('.knife-original-view').attr('src'),
      getproductname = $(this).data('product'),
      opt1 = $(this).data('option1'),
      getproductid = $(this).val(),
      getvid = $(this).parent().find('.product_current_variant').val(),
      getdata = $(this).parent().find('.proudct_data').html(),
      disabled = $(this).hasClass('disabled'),
      productdata = JSON.parse(getdata),
      variants = productdata.variants,
      vIndex = variants.length - 1,
      oIndex = productdata.options.length - 1,
      vIndex2 = variants.length - 2;
  var optitle = productdata.options[oIndex];
  	  optitle = optitle.toLowerCase();
  
  // console.log("productdata",productdata)
  if(optitle == 'gift wrapper' || optitle == 'gift wrap'){
    $('.gift_wrapper_block').slideDown();
    var variant = variants[vIndex2];
  }else{
    var variant = variants[vIndex];
    $('.gift_wrapper_block').slideUp();
  }
  var gift_wrapper = ""
  if($('[name=gift_wrapper]').length){
    gift_wrapper = $('[name=gift_wrapper]:checked').val();
  }
  
  for(let x = 0; x < variants.length; x++){
    let v = variants[x];
    if(v.option1 == opt1){
      if(productdata.options[1] && productdata.options[1].toLowerCase() == "gift wrapper"){
        if(v.option2 == gift_wrapper){
          variant = v;
        }
      }else if(productdata.options[2] && productdata.options[2].toLowerCase() == "gift wrap"){
        if(v.option3 == gift_wrapper){
          variant = v;
        }
      }
    }
  }
  
  if(variant.available == false){
    $('.addToCart_button .add-to-cart').attr('disabled','disabled');
    $('.addToCart_button .add-to-cart span').text('Sold Out');
  }else{
    $('.addToCart_button .add-to-cart').removeAttr('disabled','disabled'); 
    $('.addToCart_button .add-to-cart span').text('Add to cart');
  }
  if(productdata.handle == 'itamae-series-knife-set' || productdata.handle == 'san-mai-set'){
    $('.gift_wrapper_block .title').html("Gift wrap with card? + "+theme.Currency.formatMoney(25000, theme.settings.moneyFormat));
  }else{
    $('.gift_wrapper_block .title').html("Gift wrap with card? + "+theme.Currency.formatMoney(15000, theme.settings.moneyFormat));
  }
  var blank = 0;
  for(let v = 0; v < variants.length; v++){
    let option1 = variants[v].option1;
    if(option1 == 'Knife + Sheath + Laser Engraving'){
      blank++
    }
  }
  
  if(blank!=0){
    $('.sheath_wrapper_block').slideDown();
  }else{
    $('.sheath_wrapper_block').slideUp();
  }
  
  $('.product_select_button').removeClass('active');
  $(this).addClass('active');
  $('.customize_image #default_img').attr('src',getimage);
  $('.get_proudct_data').html(getdata);
  $('.customize_image .product_select_name').val(productdata.handle);
  $('.dm-js-form').attr('data-productid' ,productdata.id);
  
  if(disabled){
    $('.addToCart_button .add-to-cart').attr('disabled','disabled');
    $('.addToCart_button .add-to-cart span').text('Sold Out');
  }else{
    $('.addToCart_button .add-to-cart').removeAttr('disabled','disabled'); 
    $('.addToCart_button .add-to-cart span').text('Add to cart');
  }

  $('.dm-js-form .product-select').val(variant.id);
  $('.gift_wrapper_btn').removeClass('active');
  $('.gift_wrapper_btn input').removeAttr("checked");
  $('.gift_wrapper_btn input[value="No"]').parent().addClass('active');
  $('.gift_wrapper_btn input[value="No"]').attr("checked",true);
  
  var text_title = $('#inputText-f-0').val();
  DrawPlaceholder(text_title);	
  setTimeout(function(){
  	DrawPlaceholder(text_title);	
  },10);

  // getProductData('.gift_wrapper_btn', '.sheath_wrapper_block', $('.gift_wrapper_btn'),2);
});


function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  console.log(b64Data,'b64Data')
  var byteCharacters = atob(b64Data);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

// $('.addToCart_button .add-to-cart').click(function(){
//   $(this).attr('disabled','disabled');
  
//  var $id = $('.dm-js-form').attr('id');
//   var form = document.getElementById($id);

//   var ImageURL = canvas.toDataURL();
  
//   var block = ImageURL.split(";");
//   var contentType = block[0].split(":")[1];
//   var realData = block[1].split(",")[1];
//   var blob = b64toBlob(realData, contentType);
//   var formDataToUpload = new FormData(form);

//   formDataToUpload.append("properties[Front Preview]", blob);
  
 
//   console.log(formDataToUpload,'formDataToUpload');
//   $.ajax({
//     url: '/cart/add.js',
//     dataType: 'json',
//     contentType:false,
//     processData:false,
//     cache: false,
//     type: 'post',
//     data: formDataToUpload,
//     success: function(itemData) {
//       window.location.href = '/cart';
//     }
//   });
// });


$('.addToCart_button .add-to-cart').click(function(){
  $(this).attr('disabled','disabled');
  
  var $id = $('.dm-js-form').attr('id');
  var form = document.getElementById($id);
  var ImageURL = canvas.toDataURL();
  var block = ImageURL.split(";");
  var contentType = block[0].split(":")[1];
  var realData = block[1].split(",")[1];
  var blob = b64toBlob(realData, contentType);
  var formDataToUpload = new FormData(form);

  formDataToUpload.append("properties[Front Preview]", blob);
    
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    contentType:false,
    processData:false,
    cache: false,
    type: 'post',
    data: formDataToUpload,
    success: function(itemData) {
      window.location.href = '/cart';
    }
  });
});



var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

function forEach(selector,options) {
  $(selector).each(function() {
    var itsThis = $(this).find('input'),
        getInputVal = itsThis.val();
    if (getInputVal == options) {
      itsThis.click();
    }
  })
}